import Login from './Login';
import Page404 from './Page404';
import Page500 from './Page500';
import Register from './Register';
import Setting from './Mysetting';
import ForgetPw from './ForgetPw';
import ChangePw from './ChangePw';
import List from './List';
import Home from './Home';
import Help from './Help';
import ContactUs from './ContactUs';
import TOC from './TOC';
import PP from './PP';
export {
  Login, Page404, Page500, Setting, Register, ForgetPw, ChangePw, List, Home, Help, ContactUs, TOC, PP
};


// WEBPACK FOOTER //
// ./src/views/Pages/index.js